<template>
    <CascadingScalePerformanceValuesInput
      v-model="scope.row.model"
      :performance-value-name="performanceValueName"
      style="width: 100%"
      @change="scope.row.save()"
    ></CascadingScalePerformanceValuesInput>
</template>

<script>

import CascadingScalePerformanceValuesInput from "@/modules/cascading/components/scale/CascadingScalePerformanceValuesInput.vue";

export default {
  name: 'cascading-scale-performance-values-input-table-column',
  components: { CascadingScalePerformanceValuesInput},
  mixins: [],

  props: {
    scope: {type: Object, required: false},
    performanceValueName: {type: String, required: true},
  },
  data() {
    return {}
  },
  methods: {}
}

</script>

<style lang="scss">
@import "@/assets/css/project-variables";

</style>
